import {LocationGroupGranularityType} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/LocationPropertyTypeStrategy/enum/LocationGroupGranularityType'
import {
  buildLocationBucketFullValue,
  isLocationBucketLevel,
  LOCATION_COMPONENT_BY_GRANULARITY,
  LocationBucketLevel,
  toLocationBucketKey,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/LocationPropertyTypeStrategy/locationBucket'
import {
  ILocationValue,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/LocationPropertyTypeStrategy/types/ILocationPropertyTypeInterfaces'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'
import {IGroupGranularityDescriptor} from '@toolify/client/src/modules/databases/utils/groupSortModes'

export const LOCATION_GRANULARITY_FULL_LABEL_KEYS: Record<LocationGroupGranularityType, string> = {
  [LocationGroupGranularityType.Address]: 'database.header.granularityLocationAddress',
  [LocationGroupGranularityType.City]: 'database.header.granularityLocationCity',
  [LocationGroupGranularityType.Country]: 'database.header.granularityLocationCountry',
}

export const LOCATION_GRANULARITY_SHORT_LABEL_KEYS: Record<LocationGroupGranularityType, string> = {
  [LocationGroupGranularityType.Address]: '',
  [LocationGroupGranularityType.City]: 'database.header.granularityLocationCityShort',
  [LocationGroupGranularityType.Country]: 'database.header.granularityLocationCountryShort',
}

export function getLocationBucketLevel(granularity: unknown): LocationBucketLevel | null {
  return isLocationBucketLevel(granularity) ? granularity : null
}

export const locationGroupGranularityDescriptor: IGroupGranularityDescriptor = {
  getDefault: () => LocationGroupGranularityType.Address,
  getValues: () => Object.values(LocationGroupGranularityType),
  getFullLabelKey: (value: string): string =>
    LOCATION_GRANULARITY_FULL_LABEL_KEYS[value as LocationGroupGranularityType] ?? '',
  getShortLabelKey: (value: string): string =>
    LOCATION_GRANULARITY_SHORT_LABEL_KEYS[value as LocationGroupGranularityType] ?? '',
  icon: IconNameType.MapPin,
  bucketValue: (value, fullValue, granularity) => {
    const level = getLocationBucketLevel(granularity)
    if(level === null) {
      return {
        value,
        fullValue,
      }
    }
    const location = (fullValue ?? value) as Partial<ILocationValue> | null
    const component = toLocationBucketKey(location?.addressComponents?.[LOCATION_COMPONENT_BY_GRANULARITY[level]])
    if(component === null) {
      return {
        value: null,
        fullValue: null,
      }
    }
    return {
      value: {
        level,
        value: component,
      },
      fullValue: buildLocationBucketFullValue(level, component),
    }
  },
}
